import React from 'react';
import Layout from '../../../components/layout/layout'
import Header from '../../../components/header/header'
import Nav from '../../../components/nav/nav'
import Footer from '../../../components/footer/footer'
import soteCatalogCover from '../../../assets/images/albums/installations/curatorial-projects/state-of-the-earth-catalogue-cover.jpg'
import earthMonthPoster from '../../../assets/images/albums/installations/curatorial-projects/earth-month-final-poster.jpg'
import thawCatalogCover from '../../../assets/images/albums/installations/curatorial-projects/thaw_catalog_cover.jpg'
import faunaFloraCover from '../../../assets/images/albums/installations/curatorial-projects/faunaflora-midway.jpg'

export default () => (
  <Layout>
    <Header />
    <Nav />
    <main>
      <h2>Curatorial Vision:</h2>

      <p>As an independent curator and organizer in today's ever-changing landscape, it is crucial to analyze and investigate socio-political events and environmental issues through art, as everything is interconnected.</p>
      <p>I began this practice with the belief that collaboration with artists can raise awareness, educate the public and promote action on social and environmental issues. I organize these curatorial projects one or two times a year.</p>
      <p>It is important to foster diversity and intelligent dialogue, practicing collaboration and experimentation to present the results in accessible spaces for a broad audience.</p>
      <p>When selecting artists' works, I look for pieces that amaze and inspire me, as well as those that connect with the common vision of the project. Artists are inspiring thinkers and can transform our worldview through creativity, research and experiences.</p>
      <p>My curatorial aspiration is to join forces with non-profit cultural institutions, artist-run galleries, and alternative spaces, showcasing talented and underrepresented women artists from around the world. These artists aim to raise awareness and inspire diverse audiences to take action through provocative exhibitions.</p>

      <h2>
      Chronicles of Earth's Resilience: Fauna & Flora 
      </h2>

      <p>Partnering with Earth Day Organization<br />
      <a href="https://www.earthday.org/earth-day-2025/#map" target="_blank" rel="noopener noreferrer">https://www.earthday.org/earth-day-2025/#map</a>
      </p>

      <p>Earth Month exhibition at Midway Gallery, Boston<br />
      Curated by Liliana Folta</p>

      <p>This exhibition explores the interconnectedness of our natural world. From the carbon-sinks of our forests to the wildlife of our fields, 
      these featured artists examine the Earth’s self-regulating systems and its powerful ability to recover and adapt.<br />
      Folta's project was made possible by a Private Donor.</p>

      <p>Catalog:<br/></p>

      <a
        href="https://heyzine.com/flip-book/5f56227a09.html#page/1"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={faunaFloraCover} alt="Cover image for the exhibition 'Chronicles of Earth's Resilience: Fauna & Flora'" />
      </a>

      <br />
      <br />
      <br />
  
      <h2>
      THAW: We Are in Peril
      </h2>

      <p>
      Art and Science Exhibition<br/>
      Curated by Liliana Folta<br/>
      Lecture by science journalist and writer Angela Posada-Swafford:<br/>
      Expeditions in Antarctica "Tales From an Ice Argonaut".
      </p>

      <a 
        href="https://midwayartiststudios.org/thaw-we-are-in-peril/" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        https://midwayartiststudios.org/thaw-we-are-in-peril/
      </a><br/><br/>

      <p>
      The exhibition features a collaboration with the Universidad Católica Argentina (UCA) Buenos Aires. Participation of invited Artists and the i3C Artists Group (Inspiring Change for the Climate Crisis) The artists present works in various media on the theme of melting glaciers, from sculpture, painting,  video installation, sound, poem to mixed media.
      </p>

      <p>
      Permanent virtual exhibition on the website of the Universidad Católica Argentina (UCA) Buenos Aires.<br/>
      Curated by Verónica Parselis<br/>
      
      </p>

      <a
        href="https://biblioteca.uca.edu.ar/expo/deshielo/parselis.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://biblioteca.uca.edu.ar/expo/deshielo/parselis.html
      </a><br/><br/>

      <p>
      Folta's project was made possible by a Private Donor.<br/>
      Angela Losada-Swafford's lecture sponsored by Midway Artist Studios.
      </p>

      <p>Catalog:<br/></p>

      <a
        href="https://heyzine.com/flip-book/c507507fc3.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={thawCatalogCover} alt="Catalog for the THAW: We are in Peril exhibition." />
      </a>

      <br />
      <br />
      <br />

      <h2>
        EARTH MONTH: Environmental Awareness
      </h2>

      <p>
        April is EARTH MONTH, a time when people around the world celebrate our planet and take action to protect it. Every year on April 22, EARTH DAY is the largest civic event in the world, with more than one billion people participating. Fort Point Arts Community welcomes this observance by inspiring and raising awareness about the importance of climate change.
      </p>

      <p>
        “EARTH MONTH: Environmental Awareness project”  an exhibition curated by Liliana Folta, celebrates the collective effort for substantial environmental and social change through artistic mixed media, installations and public art. The official organizational theme for EARTH DAY  2025 is “renewable energy”, although the project extends to a variety of environmental and social issues in which everything is connected.
      </p>

      <p>
        The exhibition presents visual forms of intellectual understanding and engages viewers on an emotional level of consciousness to protect our Planet. This exciting collective effort with local artists focuses on social, emotional and environmental ecology. Artists, members of FPAC, guests and the i3C Artists Group (Inspiring Change for the Climate Crisis) are invited to explore the relation on how social behavior affects the people, land, water and air. They have a deep connection with repurposed and recycled materials that are polluting the planet. This diverse display of artworks shines a light on the  challenges humanity and the environment are facing.
      </p>

      <p>
        <span>Exhibition: "EARTH MONTH: Environmental Awareness"</span><br />
        <span>Curator: Liliana Folta</span><br />
        <span>Main venue: Fort Point Arts Community Art Space @ The Envoy - 70 Sleeper St. Boston</span><br />
        <span>Dates: April 1 to 30 - 2025 -  Opening reception @ Art Space,  April 12 - 6pm to 8pm</span><br />
      </p>

      <p>
        <span>Collaboration venues in Fort Point with gallery stroll will be 20 minutes each.</span><br />
        <span>Starts @ Midway Gallery/Project Room at 4:30pm -15 Channel Center St. Boston</span><br />
        <span>Continues with 249 A St Gallery and 259 A st. Gallery. Walk ends with the opening reception at FPAC Art Space.</span><br />
      </p>

      <p>
        Folta's project is made possible thanks to the support of a generous Private Donor.
      </p>

      <a
        href="https://www.fortpointarts.org/events/earth-month/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={earthMonthPoster} alt="Poster for the Earth Month exhibition." />
      </a>

      <br />
      <br />
      <br />

      <h2>
        "State of the Earth" - 21 Women Artists on Global Biodiversity Crisis
      </h2>
      <p>
        Liliana Folta<br />
        <span style={{ fontStyle: 'italic' }}>
          Interdisciplinary Artist and Independent Curator
        </span><br />
        <span style={{ fontStyle: 'italic' }}>
          Advocate of native plants
        </span>
      </p>
      <p>
        This catalog compiles the works of 21 women artists from different parts of the world, whose new proposals represent a concern for the biodiversity of their homeland or the places they chose to live.
      </p>
      <p>
        A year and a half in the making, the project was presented at the Midway Gallery in Boston, Massachussetts, September 2023.
      </p>
      <p>
        This project is partnering with the Pontificia Universidad Católica Argentina - Buenos Aires, for the extended exhibition in their virtual gallery.<br /><br />
        Co-curated with Verónica Parselis, Professor of Philosophy and Aesthetics.
      </p>
      <a 
        href="https://biblioteca.uca.edu.ar/expo/visiones/visiones.html" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        https://biblioteca.uca.edu.ar/expo/visiones/visiones.html
      </a><br /><br />
      <a
        href="https://midwayartiststudios.org/exhibitions/state-of-emergency-state-of-the-earth/"
        target="_blank"
        rel="noopener noreferrer"
      >
        https://midwayartiststudios.org/exhibitions/state-of-emergency-state-of-the-earth/
      </a><br /><br />
      <p>Catalog:&nbsp;</p>
      <a
        href="https://heyzine.com/flip-book/1aa0b6c23c.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={soteCatalogCover} alt="Interactive flipbook for State of the Earth catalogue" />
      </a>
    </main>
    <Footer />
  </Layout>
)
